import React from 'react'
import { FormattedMessage } from 'react-intl'
import { TONE } from '../../data/constants'

// These are full Discover totals calculated before the report limits its visible rows.
export const buildShadowAiStats = (appsData = {}, usersData = {}, usersAvailable = true) => {
  const unsanctionedApps = appsData.unsanctionedTotal ?? 0
  const pendingApps = appsData.pendingTotal ?? 0
  const usersOnUnsanctioned = usersAvailable ? (usersData?.total ?? 0) : '-'
  const discoverUsersTotal = usersAvailable ? usersData?.discoverUsersTotal : undefined
  let usersTone = TONE.NEUTRAL

  if (usersAvailable) {
    usersTone = usersOnUnsanctioned ? TONE.DANGER : TONE.OK
  }

  return [
    {
      key: 'unsanctionedApps',
      value: unsanctionedApps,
      tone: unsanctionedApps ? TONE.DANGER : TONE.OK,
      label: <FormattedMessage id="AI_RISK_REPORT.THIRD.SHADOW_AI.STAT_UNSANCTIONED_APPS" />,
    },
    {
      key: 'usersOnUnsanctioned',
      value: usersOnUnsanctioned,
      denom: discoverUsersTotal,
      tone: usersTone,
      label: <FormattedMessage id="AI_RISK_REPORT.THIRD.SHADOW_AI.STAT_UNSANCTIONED_USERS" />,
    },
    {
      key: 'pendingReview',
      value: pendingApps,
      tone: pendingApps ? TONE.WARN : TONE.NEUTRAL,
      label: <FormattedMessage id="AI_RISK_REPORT.THIRD.SHADOW_AI.STAT_PENDING_REVIEW" />,
    },
  ]
}
